import React, { Fragment } from 'react';
import {Checkbox ,FormControl,FormGroup,FormControlLabel,Grid} from '@material-ui/core'
import {useSelector} from 'react-redux'
import {isEmpty} from 'lodash'

import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { KeyboardDatePicker,DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import IconButton from "@material-ui/core/IconButton";
import moment from 'moment';
import IntlMessages from 'util/IntlMessages';

function CheckBoxInput(props) {
    const AvtalTyp = useSelector(state => state.accountsData.AvtalTyp)
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const onChangeHandle = (date)=>{
        let ndate = moment(date).format("YYYY-MM-DD")
        let Nstate = props.Mstate.map(item =>{
            if(item.Meta === `${props.Meta} F.O.M`){
                return {Meta:`${props.Meta} F.O.M`,Value:ndate,Checked:true}
            }else{
                return item
            }
        })
        props.onChangeMstate(Nstate)
    }
    const onChangeHandle2 = (date)=>{
        let ndate = moment(date).format("YYYY-MM-DD")
        let Nstate = props.Mstate.map(item =>{
            if(item.Meta === `${props.Meta} T.O.M`){
                return {Meta:`${props.Meta} T.O.M`,Value:ndate,Checked:true}
            }else{
                return item
            }
        })
        props.onChangeMstate(Nstate)
    }
    const ChangeMstate=(e)=>{
        let Nstate = props.Mstate.map(item =>{
            if(item.Meta === props.Meta){
                return {Meta:props.Meta,Value:0,Checked:e.target.checked}
            }
            else if(`${props.Meta} T.O.M` === item.Meta){
                return {Meta:`${props.Meta} T.O.M`,Value:moment(new Date()).format("YYYY-MM-DD"),Checked:e.target.checked}
            }
            else if(`${props.Meta} F.O.M` === item.Meta){
                return {Meta:`${props.Meta} F.O.M`,Value:moment(new Date()).format("YYYY-MM-DD"),Checked:e.target.checked}
            }
            else{
                return item
            }
        })
        props.onChangeMstate(Nstate)
    }
    console.log(props.Mstate)
    return (
        
            <FormControl component="fieldset" fullWidth>
                <FormGroup aria-label="position"  row>
                <FormControlLabel
                value={true}         
                control={
                    (props.Meta !== 'Order skapad datum' || 
                    props.Meta !== 'Order registrering datum')?
                <Checkbox color="primary" 
                checked={props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                onChange={(e)=>{
                        ChangeMstate(e)
                    }                    
                }
                />
                :""}
                label={<Grid 
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    >
                        <Grid item xs={6}>
                <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
                <Fragment>
                <KeyboardDatePicker
                   inputVariant="outlined"
                   invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                   className="px-1"
                   label={`${props.Meta} F.O.M:`}
                   disabled={!props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                   size="small"
                   name={`${props.Meta} F.O.M`}
                   format="yyyy-MM-dd"
                   variant="outlined"
                   cancelLabel={<IntlMessages id="Cancel"/>}
                   animateYearScrolling
                   value={props.Mstate.filter(item=>{return item.Meta === `${props.Meta} F.O.M`})[0].Value}
                   onChange={(date)=>onChangeHandle(date)}
                   KeyboardButtonProps={{
                    "className": "px-0 m-0 btn btn-sm"
                   }}
                    />   
                </Fragment>
                </MuiPickersUtilsProvider>
            </Grid>
           
              <Grid item xs={6}> 
                <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
                <Fragment>
                <KeyboardDatePicker
                   inputVariant="outlined"
                   invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                   label={`${props.Meta} T.O.M:`}
                   className="px-1"
                   disabled={!props.Mstate.filter(item=>{return item.Meta === props.Meta})[0].Checked}
                   size="small"
                   name={`${props.Meta} T.O.M`}
                   format="yyyy-MM-dd"
                   cancelLabel={<IntlMessages id="Cancel"/>}
                   variant="outlined"
                   animateYearScrolling
                   value={props.Mstate.filter(item=>{return item.Meta === `${props.Meta} T.O.M`})[0].Value}
                   onChange={(date)=>onChangeHandle2(date)}
                   KeyboardButtonProps={{
                    "className": "px-0 m-0 btn btn-sm"
                   }}
                    />   
                </Fragment>
                </MuiPickersUtilsProvider>
                </Grid>
        </Grid>
                }
                labelPlacement={"end"}
                />
                </FormGroup>
                
             </FormControl>
    );
}

export default CheckBoxInput;